export default {"src":"/_next/static/media/economic.34663aa2.svg","height":25,"width":26,"blurWidth":0,"blurHeight":0};